const tipElement = document.createElement("div");
tipElement.className = "tip";
document.body.appendChild(tipElement);
document.addEventListener("mousemove", (event) => {
	const path = event.composedPath();
	for (const element of path) {
		const tipContent = element instanceof HTMLElement && (element.getAttribute("tip") || element.getAttribute("data-tip"));
		const tipPosition = element instanceof HTMLElement && (element.getAttribute("tipPosition") || element.getAttribute("data-tipPosition"));
		if (tipContent) {
			const rect = element.getBoundingClientRect();

			tipElement.innerHTML = tipContent;
			tipElement.style.left = `${rect.x}px`;
			tipElement.style.top = `${rect.y + rect.height + 4}px`;
			tipElement.classList.add("show");

			if (tipPosition === "center") {
				tipElement.style.left = `${Math.max(rect.x + rect.width / 2 - tipElement.offsetWidth / 2, 0)}px`;
			} else if (tipPosition === "left") {
				tipElement.style.left = `${rect.x}px`;
			} else if (tipPosition === "right") {
				tipElement.style.left = `${Math.max(rect.x + rect.width - tipElement.offsetWidth, 0)}px`;
			} else if (tipPosition === "up") {
				tipElement.style.top = `${Math.max(rect.y - tipElement.offsetHeight - 4, 0)}px`;
			}
			//
			if (tipContent) return;
		}
	}
	tipElement.classList.remove("show");
});
document.addEventListener("mouseleave", () => tipElement.classList.remove("show"));
document.addEventListener("mousedown", () => tipElement.classList.remove("show"));
document.addEventListener("mouseup", () => tipElement.classList.remove("show"));
